import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";
import MetricDonutChart from "../charts/MetricDonutChart";
import MetricCard from "../metrics/MetricCard";
import SimpleLabel from "../metrics/SimpleLabel";

const EducationMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("education data:", sortedMetrics);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    // Define metrics for order
    const e: DisaggregatedMetric[] = sortedMetrics[0];
    const b = indicators?.find(i => i.id === 1215);
    const m = indicators?.find(i => i.id === 1218);
    const hs = indicators?.find(i => i.id === 1220);

    return (
        <div className="grid grid-cols-2 gap-4">
        {b && (
            <div className="space-y-2 mx-2">
                <MetricDonutChart metric={b} />
                <SimpleLabel
                    key={b.id}
                    id={b.id}
                    title={b.name}
                    svg={getSvgMap(b.id)}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
        )}

        {m && (
            <div className="space-y-2 mx-2">
                <MetricDonutChart metric={m} />
                <SimpleLabel
                    key={m.id}
                    id={m.id}
                    title={m.name}
                    svg={getSvgMap(m.id)}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
        )}

        {hs && (
            <div className="space-y-2 mx-2">
                <MetricDonutChart metric={hs} />
                <SimpleLabel
                    key={hs.id}
                    id={hs.id}
                    title={hs.name}
                    svg={getSvgMap(hs.id)}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
        )}

        {e?.map(metric => (
            <MetricCard
                key={metric.id}
                metric={metric}
                width="w-full"
                svg={getSvgMap(metric.id)}
                disaggData={indicators}
                geoDetails={geoDetails}
                geoTag={geoTag}
                selectionActive={selectionActive}
            />
        ))}
    </div>
    );
}

export default EducationMetrics;